import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import { OWNER, OR_ADMIN, OR_SUPERUSER, BILLING, OR_READONLY, OR_SUPERREAD } from 'constants/roles';
import RBACWrapper from 'components/RBACWrapper/RBACWrapperContainer';
import BillingCardContainer from './BillingCard/BillingCardContainer';
import InvoiceCardContainer from './InvoiceCard/InvoiceCardContainer';
import PromotionCardContainer from './PromotionCard/PromotionCardContainer';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    leftCol: PropTypes.string.isRequired,
    rightCol: PropTypes.string.isRequired,
    card: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledBillingTab({ classes }) {
  return (
    <div className={classes.root}>
      <div className={classes.leftCol}>
        <RBACWrapper roles={[OWNER, BILLING, OR_SUPERUSER, OR_ADMIN]}>
          <BillingCardContainer className={classes.card} />
        </RBACWrapper>
        <RBACWrapper roles={[OWNER, BILLING, OR_SUPERUSER, OR_ADMIN, OR_READONLY, OR_SUPERREAD]}>
          <PromotionCardContainer className={classes.card} />
        </RBACWrapper>
      </div>
      <div className={classes.rightCol}>
        <RBACWrapper roles={[OWNER, BILLING, OR_SUPERUSER, OR_ADMIN, OR_READONLY, OR_SUPERREAD]}>
          <InvoiceCardContainer className={classes.card} />
        </RBACWrapper>
      </div>
    </div>
  );
}

UnstyledBillingTab.propTypes = propTypes;

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  leftCol: {
    flex: 1,
  },
  rightCol: {
    flex: 1,
  },
  card: {
    '&:not(:first-child)': {
      marginTop: theme.spacing(1),
    },
  },

  [theme.breakpoints.down('md')]: {
    root: {
      flexDirection: 'column',
    },
    rightCol: {
      marginTop: theme.spacing(1),
    },
  },

  [theme.breakpoints.up('lg')]: {
    leftCol: {
      marginRight: theme.spacing(1),
    },
    rightCol: {
      marginLeft: theme.spacing(1),
    },
  },
});

export default withStyles(styles)(UnstyledBillingTab);
